import axios from "axios";
import { handleSuccess, handleError } from "./helpers";

const quoteAPI = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}api/`,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    Accept: "application/json",
  },
  withCredentials: false,
});

quoteAPI.interceptors.response.use(handleSuccess, handleError);

export default quoteAPI;
